import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../services/context";
import { baseURL } from "../services/axios/eps";
import { IoMdNotifications } from "react-icons/io";
import {
  fetchNotificationsList,
  getAdminNotifsCount,
} from "../services/axios/apiManager";
import { handleErrors } from "../services/dataManager";
import { format } from "date-fns";
import { empLogout } from "../services/axios/apiManager";
import { logoutOnesignal } from "../services/onesignal";

const Header = () => {
  const { state, setState } = useAppContext();
  const { user, notifsCount } = state;

  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationsDropDownOpen, setIsNotificationsDropDownOpen] =
    useState(false);
  // const [notifsCount, setNotifsCount] = useState();
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);

  const titleMap = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/users": "Users",
    "/employees": "Employees",
    "/role": "Roles",
    "/permissions": "Permissions",
    "/AdsApi": "Ads APIs",
    "/GamingPlatformManagement": "Games",
    "/CharitableOrganization": "Charitable Organizations",
    "/Country": "Countries",
    "/Province": "Provinces",
    "/City": "Cities",
    "/FaqsManagement": "FAQs",
    "/BlogsManagement": "Blogs",
    "/KbManagement": "Knowledge Base",
    "/rolePermissions": "Role Permissions",
    "/userPermissions": "User Permissions",
    "/AdminProfile": "Profile",
    "/reports": "Reports",
    "/all-reports": "All Reports",
    "/badges": "Badges",
    "/achievements": "Achievements",
    "/trouble-tickets": "Trouble Tickets",
    "/contactUs": "Contact Us",
    "/customPages": "Custom Pages",
    "/seo-management": "SEO Management",
    "/tags": "Tags",
    "/gamecategory": "Game Categories",
    "/GameSubcategory": "Game Subcategories",
    "/Banner": "Banners",
    "/providers": "Providers",
    "/bugs": "Bugs",
    "/game-reviews": "Game Reviews",
    "/manage-notifications": "Notifications",
    "/notifications": "All Notifications",
    "/HomePage": "Home Page",
    "/AboutUs": "About Us",
    "/TermsPage": "Terms & Conditions",
    "/PrivacyPolicyPage": "Privacy Policy",
    "/country": "Countries",
    "/province": "Provinces",
    "/city": "Cities",
    "/homePage":"Mange Home Page",
    "/banner":"Manage Banners",
    "/aboutPage":"Manage About US",

  };

  const getPageTitle = (pathname) => {
    if (titleMap[pathname]) return titleMap[pathname];

    if (pathname.startsWith("/UserProfile/")) return "User Profile";
    if (pathname.startsWith("/EmployeeProfile/")) return "Employee Profile";
    if (pathname.startsWith("/ViewGame/")) return "View Game";
    if (pathname.startsWith("/editGame/")) return "Edit Game";
    if (pathname.startsWith("/CharitableOrganization/details/"))
      return "Charitable Profile";
    if (pathname.startsWith("/AddEditEmployee/")) return "Employee Management";
    if (pathname.startsWith("/BlogsManagement/edit/")) return "Edit Blog";
    if (pathname.startsWith("/BlogsManagement/add")) return "Add Blog";
    if (pathname.startsWith("/KbManagement/edit/")) return "Edit Article";
    if (pathname.startsWith("/KbManagement/add")) return "Add Article";

    return "Dashboard";
  };

  const currentTitle = getPageTitle(location.pathname);

  const toggleDropdown = () => {
    setIsNotificationsDropDownOpen(false);
    setIsDropdownOpen((prev) => !prev);
  };

  const getNotifsCount = async () => {
    const res = await getAdminNotifsCount();
    if (res?.data?.success && res?.data?.data) {
      const { count } = res.data.data;
      setState((prev) => ({ ...prev, notifsCount: count || 0 }));
    }
  };

  const getNotificationForDropdown = async () => {
    const res = await fetchNotificationsList(1, 20);
    if (res?.data?.success && res?.data?.data) {
      setNotifications(res?.data?.data);
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".profile-dropdown")) {
        setIsDropdownOpen(false);
        setIsNotificationsDropDownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const handleLogout = async () => {
    const res = await empLogout();
    if (res?.data?.success) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      await logoutOnesignal();
      navigate("/login");
    }
  };
  function handleClick() {
    navigate("/AdminProfile");
  }

  useEffect(() => {
    getNotifsCount();
    getNotificationForDropdown();
  }, []);

  return (
    <header
      className="navbar navbar-expand-lg navbar-dark"
      style={{ background: "#000" }}
    >
      <div className="container-fluid">
        <span className="navbar-brand fw-bold fs-4">{currentTitle}</span>

        <div className="justify-content-end" id="navbarNav">
          <ul className="navbar-nav align-items-center">
            <li className="nav-item profile-dropdown position-relative">
              <button
                className="text-light"
                onClick={() => {
                  setIsDropdownOpen(false);
                  setIsNotificationsDropDownOpen(!isNotificationsDropDownOpen);
                }}
                style={{
                  transition: "color 0.3s ease",
                  height: "50px",
                  width: "50px",
                }}
              >
                <IoMdNotifications
                  style={{
                    transition: "color 0.3s ease",
                    height: "40px",
                    width: "40px",
                    marginLeft: "5px",
                    marginTop: "8px",
                  }}
                />
                {notifsCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "12px",
                      color: "aliceblue",
                      backgroundColor: "#39FF14",
                      height: "10px",
                      width: "10px",
                      borderRadius: "5px",
                      right: "13px",
                    }}
                  />
                )}
              </button>
              {isNotificationsDropDownOpen && (
                <div className="dropdown-menu shadow show dropdown-menu-dark notif-dropdown">
                  {/* {notifications?.length>0 && ( */}
                  <div className="header">
                    <button
                      onClick={() => {
                        navigate("/notifications");
                      }}
                    >
                      <span className="header-text">View All</span>
                    </button>
                  </div>
                  {/* )} */}
                  {notifications?.length ? (
                    notifications?.map((item, index) => (
                      <div
                        className="notification-item"
                        // onClick={() => {
                        //   navigate("/notifications");
                        // }}
                        key={index}
                      >
                        <div className="notification-header">
                          <span className="notification-title">
                            {item?.title}
                            {!item?.is_read && <span className="title-dot" />}
                          </span>
                          <span className="notification-date">
                            {item?.createdAt && format(item.createdAt, "PP")}
                          </span>
                        </div>
                        <div className="notification-message">
                          <p>{item?.message}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <span
                      style={{
                        color: "white",
                        fontWeight: "500",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "5px",
                        textAlign: "center",
                      }}
                    >
                      No notifications
                    </span>
                  )}
                </div>
              )}
            </li>
            <li
              className="nav-item profile-dropdown position-relative"
              data-testid="headerDD"
            >
              <button
                type="button"
                onClick={toggleDropdown}
                data-testid="ddBtn"
                style={{
                  cursor: "pointer",
                  width: "40px",
                  height: "40px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                // style={{ background: "none", border: "none", padding: 0 }}
              >
                <img
                  crossorigin="anonymous"
                  // data-testid="ddBtn"
                  src={
                    user?.image
                      ? `${baseURL}uploads/file/${user.image}`
                      : "https://avatar.iran.liara.run/public"
                  }
                  alt="User Profile"
                  className="rounded-circle border-2 border-light"
                  // onClick={toggleDropdown}
                  // style={{
                  //   cursor: "pointer",
                  //   width: "40px",
                  //   height: "40px",
                  //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  // }}
                />
              </button>
              {isDropdownOpen && (
                <ul
                  className="dropdown-menu shadow show dropdown-menu-dark"
                  data-testid="ddoptions"
                  style={{
                    backgroundColor: "rgb(5 17 23)",
                    border: "1px solid #444",
                    minWidth: "180px",
                    position: "absolute",
                    left: "0",
                    top: "50px",
                    transform: "translateX(-100%)",
                  }}
                >
                  <li>
                    <button
                      data-testid="profBtn"
                      className="dropdown-item text-light fw-medium"
                      onClick={handleClick}
                      style={{ transition: "color 0.3s ease" }}
                      onMouseEnter={(e) => (e.target.style.color = "black")}
                      onMouseLeave={(e) => (e.target.style.color = "white")}
                    >
                      View Profile
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item text-danger fw-medium"
                      style={{ transition: "color 0.3s ease" }}
                      onMouseEnter={(e) => (e.target.style.color = "black")}
                      onMouseLeave={(e) => (e.target.style.color = "red")}
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>
      <style>
        {`
          .notif-dropdown {
            background-color: rgb(5 17 23);
            border: 1px solid #444;
            min-width: 300px;
            max-height: 500px;
            position: absolute;
            left: 25px;
            top: 50px;
            transform: translateX(-100%);
            overflow: auto;
          }
          .header{
            display:flex;
            height:30px;
            justify-content: flex-end;
            align-items: center;
            padding-right: 10px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
          .header-text{
            font-weight: 600;
            font-size: 12px;
            color: rgb(20 90 255);
          }
          .notification-item {
            display: flex;
            flex-direction: column;
            width: 100%;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            padding: 8px 5px;
          }
          .notification-header {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: space-between;
          }
          .notification-title {
            font-size: 14px;
            font-weight: 500;
            color: white;
            display: inline-block;
            max-width: 25ch; /* show up to 15 characters */
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
          }
          .title-dot{
            width: 8px;
            height: 8px;
            border-radius: 5px;
            background-color: rgb(57, 255, 20);
          }
          .notification-date {
            font-size: 9px;
            color: grey;
            font-weight: 700;
            margin-top: 3px;
          }
          .notification-message {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 2px;
          }
        `}
      </style>
    </header>
  );
};

export default Header;
